import { render, staticRenderFns } from "./LinkUnderline.vue?vue&type=template&id=fcfd57ca&scoped=true&"
import script from "./LinkUnderline.vue?vue&type=script&lang=js&"
export * from "./LinkUnderline.vue?vue&type=script&lang=js&"
import style0 from "./LinkUnderline.vue?vue&type=style&index=0&id=fcfd57ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfd57ca",
  null
  
)

export default component.exports